import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDaily, useInventory, useMe } from '@/api/hooks';
import { Table } from '@/components/Table';
import { TarotCard } from '@/components/TarotCard';
import { Skeleton } from '@/components/ui';
import { Icon } from '@/components/Icon';
import { preload } from '@/lib/preload';
import { DailyRewardSheet } from './DailyRewardSheet';

export function HomeScreen() {
  const { data: me } = useMe();
  const { data: inv } = useInventory();
  const { data: daily } = useDaily();
  const nav = useNavigate();
  const [q, setQ] = useState('');
  const [reward, setReward] = useState(false);
  const input = useRef<HTMLTextAreaElement>(null);

  const deck = inv?.decks.find((d) => d.id === me?.activeDeckId);
  useEffect(() => { preload([deck?.backStyle.image, daily?.card.imageUrl]); }, [deck?.backStyle.image, daily?.card.imageUrl]);
  if (!me || !inv) return <div className="screen"><Skeleton h={420} /></div>;

  const ask = () => {
    const question = q.trim();
    if (!question) { input.current?.focus(); return; }
    nav('/reading', { state: { question } });
  };

  return (
    <div className="screen">
      <div className="topbar">
        <div className="wallet">
          <span className="pill" onClick={() => nav('/shop')}><Icon name="crystal" size={16} className="c-crystal" />{me.wallet.crystals}</span>
          {me.wallet.tickets > 0 && <span className="pill gold"><Icon name="ticket" size={16} />{me.wallet.tickets}</span>}
        </div>
        <div className="row">
          {me.streak.current > 1 && <span className="streak"><Icon name="flame" size={14} filled />{me.streak.current}</span>}
          {me.premium ? <span className="pill gold"><Icon name="sparkle" size={14} filled />Premium</span> : (
            <span className="pill" title="Бесплатные расклады сегодня">
              <span className="dots">{Array.from({ length: me.limits.freePerDay }, (_, i) => <i key={i} className={i < (me.limits.left ?? 0) ? 'on' : ''} />)}</span>
              {me.limits.left}/{me.limits.freePerDay}
            </span>
          )}
        </div>
      </div>

      <Table slots={me.tableSlots} items={inv.items} logo>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ width: '26%', animationDelay: `${i * 0.12}s` }} className="deal" onClick={() => input.current?.focus()}>
            <TarotCard back={deck?.backStyle} />
          </div>
        ))}
      </Table>

      <div className="stack" style={{ marginTop: 12 }}>
        <div className="card">
          <textarea ref={input} className="input" rows={2} maxLength={300} placeholder="Введите вопрос картам…" value={q} onChange={(e) => setQ(e.target.value)} style={{ minHeight: 56 }} />
          <div className="row spread" style={{ marginTop: 8 }}>
            <span className="dim">Чем конкретнее вопрос, тем точнее ответ</span>
            <button className="btn primary sm" onClick={ask}><Icon name="sparkle" size={16} filled />Расклад</button>
          </div>
        </div>
        <button className="btn warm daily-btn" onClick={() => nav('/daily')}>
          {daily?.opened && daily.card.imageUrl ? <span className="mini-card" style={{ backgroundImage: `url(${daily.card.imageUrl})` }} /> : <Icon name="sun" size={20} />}
          <span className="grow">{daily?.opened ? <>Карта дня: <b>{daily.card.name}</b></> : 'Открыть карту дня'}</span>
          {!daily?.opened && <span className="dot-new" />}
          <Icon name="chevron" size={18} />
        </button>
        {me.dailyReward.available && <button className="btn ghost" onClick={() => setReward(true)}><Icon name="gift" size={18} />Ежедневная награда<span className="grow" /><Icon name="chevron" size={18} /></button>}
      </div>
      <DailyRewardSheet open={reward} onClose={() => setReward(false)} />
    </div>
  );
}
